import * as Analytics from 'analytics/Analytics';
import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import FormulaUtil from 'notebook/tables/excess/FormulaUtil';

export interface WorksheetInfo {
  worksheetId: string;
  stepCount: number;
}

/**
 * Tracks creation or deletion of cross-step references in worksheets.
 * Compares old and new cell text to detect changes in CSDR status.
 */
export function trackCrossStepReferenceChange(
  oldCellText: string,
  newCellText: string,
  worksheetInfo: WorksheetInfo | null
): void {
  if (!worksheetInfo) {
    return;
  }

  const oldHasCSR = FormulaUtil.hasCrossStepReference(oldCellText);
  const newHasCSR = FormulaUtil.hasCrossStepReference(newCellText);

  if (oldHasCSR !== newHasCSR) {
    Analytics.trackEvent(
      newHasCSR
        ? ELN_ANALYTICS_ACTIONS.CREATED_CROSS_STEP_REFERENCE
        : ELN_ANALYTICS_ACTIONS.DELETED_CROSS_STEP_REFERENCE,
      {
        action_origin: ActionOrigin.WORKSHEET,
        worksheet_id: worksheetInfo.worksheetId,
        step_count: worksheetInfo.stepCount,
      }
    );
  }
}

/**
 * Tracks deletion of cross-step references when multiple cells are cleared at once.
 * Emits one event per deleted CSDR.
 */
export function trackCrossStepReferenceBulkDelete(
  deletedCells: Array<{text: string}>,
  worksheetInfo: WorksheetInfo | null
): void {
  if (!worksheetInfo) {
    return;
  }

  deletedCells.forEach((cell) => {
    if (FormulaUtil.hasCrossStepReference(cell.text)) {
      Analytics.trackEvent(ELN_ANALYTICS_ACTIONS.DELETED_CROSS_STEP_REFERENCE, {
        action_origin: ActionOrigin.WORKSHEET,
        worksheet_id: worksheetInfo.worksheetId,
        step_count: worksheetInfo.stepCount,
      });
    }
  });
}
